interface IconProps {
  className?: string;
}

/** Ruble-in-circle glyph from the DubaiExpress product page mockup (customs duty row). */
const CircleRubleIcon = ({ className }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    className={className}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M10 7.5h3a2.5 2.5 0 0 1 0 5h-3V7.5zM10 12.5v4.5M8.5 15h4" />
  </svg>
);

export default CircleRubleIcon;
